import React from 'react';
import styles from './SkeletonCard.module.css';

export default function SkeletonCard() {
  return (
    <div className={styles.card} aria-hidden="true">
      <div className={styles.header}>
        <div className={styles.avatar} />
        <div className={styles.lines}>
          <div className={styles.nameLine} />
          <div className={styles.roleLine} />
        </div>
      </div>
      <div className={styles.skillsLine}>
        <div className={styles.skillBlock} />
        <div className={styles.skillBlock} />
        <div className={styles.skillBlock} />
      </div>
    </div>
  );
}
